module.exports = __webpack_public_path__ + "static/media/bg-green2.bb0c2fa0.svg";